import queryString from "query-string";
import type { NskResponse } from "~/models/Api";
import type {
	DealConstruction,
	DealConstructionEdit
} from "~/models/DealConstruction";
import { deleteRequest, postRequest } from "~/utils/api/api_handler";
import { convertDealConstructionToPayload } from "~/utils/api/convertDealConstructionPayload";
import { generatePath } from "~/utils/generatePath";

export const create = async (
	dealEstimationHistory: DealConstructionEdit,
	dealId: number,
	dealEstimationId: number | null,
	id: number | null
): Promise<NskResponse> =>
	postRequest(
		queryString.stringifyUrl({
			query: { deal_estimation_id: dealEstimationId, id },
			url: generatePath("/vendors/deals/:deal_id/deal_estimation_histories", {
				deal_id: dealId
			})
		}),
		{
			dealEstimationHistory: convertDealConstructionToPayload(
				dealEstimationHistory
			)
		}
	);

export const updateTypeDelete = async (
	dealId: number,
	dealEstimationId: number
): Promise<NskResponse> =>
	postRequest(
		queryString.stringifyUrl({
			query: { deal_estimation_id: dealEstimationId },
			url: generatePath("/vendors/deals/:deal_id/deal_estimation_histories", {
				deal_id: dealId
			})
		}),
		{
			dealEstimationHistory: {
				operationType: "delete"
			}
		}
	);

export const destroy = async (
	dealId: number,
	dealEstimationHistoryId: number
): Promise<NskResponse> =>
	deleteRequest(
		generatePath("/vendors/deals/:deal_id/deal_estimation_histories/:id", {
			deal_id: dealId,
			id: dealEstimationHistoryId
		})
	);

export const updateSeq = async (
	dealEstimationHistories: DealConstruction[],
	dealId: number
): Promise<NskResponse> =>
	postRequest(
		generatePath(
			"/vendors/deals/:deal_id/deal_estimation_histories/update_seq",
			{
				deal_id: dealId
			}
		),
		{
			dealEstimationHistories
		}
	);
